import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Helmet } from 'react-helmet-async';
import { UtilsLib } from '@payface-frontends-libs/utils';
const { googleAnalyticsConfig } = UtilsLib.Config;
const GLOBAL_GA_MEASUREMENT_ID = googleAnalyticsConfig;
export function GoogleAnalytics({ id }) {
    return (_jsxs(Helmet, { children: [_jsx("script", { async: true, src: `https://www.googletagmanager.com/gtag/js?id=${id || GLOBAL_GA_MEASUREMENT_ID}` }, void 0), _jsx("script", { children: `
          window.dataLayer = window.dataLayer || [];

          function gtag() {
            dataLayer.push(arguments);
          }

          gtag('js', new Date());
          gtag('config', '${id || GLOBAL_GA_MEASUREMENT_ID}');
        ` }, void 0)] }, void 0));
}
//# sourceMappingURL=GoogleAnalytics.js.map